import { AppstoreOutlined } from "@ant-design/icons";
import { table2dCore } from "./core/table2d";
import { defineWidget } from "../widgetDefinition";
import { table2dSlots } from "../Slots";
import { table2dDuplicate } from "../Duplication/table2d";
import { table2dControlPanel } from "../ControlPanel/table2d";
import type { Table2DComponentSpec } from "../Processing/types";
import { Table2DWidget } from "../WidgetComponents/Table2DWidget";
import { Table2DInfo } from "../Info/table2d";
import { Table2DConfigurator } from "../AddWidgetModal/Table2DConfigurator";
import { BINDABLE_SECTIONS } from "../Processing/controllerBindings";

export const table2dDefinition = defineWidget<Table2DComponentSpec>({
  ...table2dCore,
  type: "table_2d",
  dynamic: { bindableSections: BINDABLE_SECTIONS.table_2d },
  slots: table2dSlots,
  duplicate: table2dDuplicate,
  controlPanel: table2dControlPanel,
  info: { Content: Table2DInfo },
  schema: ["display", "rowDimension", "colDimension", "queryIds", "colorize", "showDataLabels", "pinnedCols", "table_2d_builder_misc"],
  contractHash: "04e1gwgfall",
  needsData: true,

  template: {
    label: "2D Table",
    description: "Cross-tabulate a metric across two dimensions, e.g. player × date",
    icon: <AppstoreOutlined />,
  },

  defaultLayout: { w: 8, h: 12, minW: 2, minH: 3 },

  gridComponent: ({ id }) => <Table2DWidget id={id} />,

  configurator: {
    modalTitle: "2D Table Widget",
    wide: true,
    Component: Table2DConfigurator as any,
  },
});
